const categories = [
  {
    title: "Books",
    categoryNumber: 10,
    difficulty: "medium",
    imageURL:
      "https://raw.githubusercontent.com/ianuragsharma/hostedIMG/main/quiz/categories/Books.png",
    description:
      "It's a collection of trivia and personality quizzes for huge book lovers — in one .",
  },
  {
    title: "Films",
    categoryNumber: 11,
    difficulty: "easy",
    imageURL:
      "https://raw.githubusercontent.com/ianuragsharma/hostedIMG/main/quiz/categories/Films.png",
    description:
      "Put your film knowledge to the test and see how many movie trivia questions you can get right. ",
  },
  {
    title: "Music",
    categoryNumber: 12,
    difficulty: "hard",
    imageURL:
      "https://raw.githubusercontent.com/ianuragsharma/hostedIMG/main/quiz/categories/Music.png",
    description:
      "Test your knowledge of types of music with this fun 10-question quiz!",
  },
  {
    title: "Computer",
    categoryNumber: 18,
    difficulty: "easy",
    imageURL:
      "https://raw.githubusercontent.com/ianuragsharma/hostedIMG/main/quiz/categories/computer.png",
    description: "Test your knowledge of computer basics by taking our quiz. ",
  },
  {
    title: "Geography",
    categoryNumber: 22,
    difficulty: "easy",
    imageURL:
      "https://raw.githubusercontent.com/ianuragsharma/hostedIMG/main/quiz/categories/geography.jpg",
    description:
      "Take a spin around the globe and see how many of these geography facts you know!",
  },

  {
    title: "Animals",
    categoryNumber: 27,
    difficulty: "easy",
    imageURL:
      "https://raw.githubusercontent.com/ianuragsharma/hostedIMG/main/quiz/categories/Animals.png",
    description: "This brain-stretching quiz will test your animal smarts!",
  },
  {
    title: "Vehicles",
    categoryNumber: 28,
    difficulty: "medium",
    imageURL:
      "https://raw.githubusercontent.com/ianuragsharma/hostedIMG/main/quiz/categories/Vehicles.png",
    description: "Put your vehicles knowledge on test with this epic quiz.",
  },
  {
    title: "Video Games",
    categoryNumber: 15,
    difficulty: "medium",
    imageURL:
      "https://raw.githubusercontent.com/ianuragsharma/hostedIMG/main/quiz/categories/video-games.png",
    description:
      "Think you are a true Video Games expert? Take one of the thousands of these addictive Video Games quizzes and prove it.",
  },
];

export { categories };
